module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/variant-b-osago-db75f95db8378e10f4e3e4580b6368fb.png.webp";